import EnlilAxios from "../../../../util/EnlilAxios";
import EnterpriseComponent from "../../EnterpriseComponent";
import {V1ProjectMilestoneSessionIDOCToArray} from "../../../../util/Payload";
import {v4 as uuidv4} from "uuid";
import {SessionContext} from "../../../../util/SessionContext";

class ProjectMilestoneSessionEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocResponse = this.getIDOCResponse() ?? "v1.ProjectMilestoneSession-001";

        let sessionContext = new SessionContext();

        let QBE = {
            "ShifamedMessage": {
                "-idoc": "v1.ProjectMilestoneSession-001",
                "-id": uuidv4(),
                "ProjectMilestoneSession": {
                    "_attributes": {
                        "limit": pageSize,
                        "sort": this.getFormattedSortSpecification(),
                        "offset": (page - 1) * pageSize
                    },
                    "QueryGroups": {
                        "QueryGroup": [
                            {
                                "Name": "QG1",
                                "Type": "QueryGroup",
                                "Operator": "AND",
                                "Membership": {
                                    "Member": [
                                        {
                                            "Type": "Attribute",
                                            "Name": "EmployeeUSID",
                                            "Value": sessionContext.getEmployeeUSID(),
                                            "Operator": "EQUAL"
                                        }
                                    ]
                                }
                            }
                        ]
                    }
                }
            }
        }

        if (foreignKey && this.getEnterpriseObject() !== null) {
            let relationship = this.getRelationshipForChildEnterpriseComponent(this);

            if (relationship) {
                QBE.ShifamedMessage.ProjectMilestoneSession.QueryGroups.QueryGroup[0].Membership.Member.push({
                    "Type": "Attribute",
                    "Name": relationship.getSourceAttribute(),
                    "Value": foreignKey,
                    "Operator": "EQUAL"
                })
            }
        }

        EnlilAxios({
            method: "GET",
            url: "t8/v1/project_milestone_sessions",
            json: true,
            params: {
                "QBE": btoa(JSON.stringify(QBE))
            },
            headers: {
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1ProjectMilestoneSessionIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };
}

export default ProjectMilestoneSessionEnterpriseComponent;